<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 md8 offset-md2>
        <v-toolbar>
          <v-toolbar-title>Cambio de contraseña</v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-alert :value="error" type="error" outline>{{ errorMessage }}</v-alert>
            <v-alert :value="success" type="success" outline>La contraseña se cambió exitosamente</v-alert>
            <v-container>
              <form @submit.prevent="changePassword">
                <v-text-field name="username" label="Usuario" :value="$store.state.authUser" type="text"
                              required readonly></v-text-field>
                <v-text-field name="password" label="Contraseña actual" v-model="oldPassword" type="password"
                              required></v-text-field>
                <v-text-field name="password" label="Contraseña nueva" v-model="newPassword" type="password" required loading>
                  <v-progress-linear
                    slot="progress" :value="progress" :color="color" height="2"></v-progress-linear>
                </v-text-field>
                <v-text-field name="password" label="Confirmar contraseña"  v-model="confirmPassword" type="password"
                              required :error-messages="confirmErrors"></v-text-field>
                <v-btn type="submit">Enviar</v-btn>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      username: '',
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      error: false,
      errorMessage: '',
      success: false
    }
  },

  computed: {
    confirmErrors () {
      if (this.confirmPassword && (this.newPassword !== this.confirmPassword)) {
        return ['La nueva contraseña no coincide con la confirmación']
      }
      return []
    },
    progress () {
      return Math.min(100, this.newPassword.length * 12.5)
    },
    color () {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)]
    }
  },

  methods: {
    setError (message) {
      this.errorMessage = message
      this.error = true
    },
    changePassword () {
      if (this.isValidForm()) {
        const payload = {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        }
        this.axios
          .put('password/change/', payload)
          .then(() => {
            this.error = false
            this.success = true
            this.cleanForm()
          })
          .catch((error) => {
            if (error && error.response && error.response.status === 400) {
              this.setError('La contraseña ingresada es incorrecta')
            } else {
              this.setError('Error de conexión con el servidor')
            }
          })
      }
    },

    isValidForm () {
      if (this.progress !== 100) {
        this.setError('Ingrese una contraseña con al menos 8 caracteres')
        return false
      }
      return true
    },

    cleanForm () {
      this.oldPassword = ''
      this.newPassword = ''
      this.confirmPassword = ''
    }
  }
}
</script>
